import { useEffect, useState, type ReactNode } from 'react';

/**
 * A button for something costly to undo (stopping an encode loses hours): the first tap only arms
 * it ("Tap again to stop"), the second within 4 s does it. A stray tap, say where the ⋯ menu
 * usually sits, can't stop anything.
 */
export function TapTwiceButton({
  className,
  armedText,
  title,
  disabled,
  onConfirm,
  children,
}: {
  className: string;
  armedText: string;
  title?: string;
  disabled?: boolean;
  onConfirm: () => void;
  children: ReactNode;
}) {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (!armed) return;
    const t = setTimeout(() => setArmed(false), 4000);
    return () => clearTimeout(t);
  }, [armed]);
  return (
    <button
      type="button"
      className={`${className}${armed ? ' tap-armed' : ''}`}
      title={title}
      disabled={disabled}
      aria-live="polite"
      onClick={() => {
        if (!armed) return setArmed(true);
        setArmed(false);
        onConfirm();
      }}
    >
      {armed ? armedText : children}
    </button>
  );
}
